import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { CompanyActiveState, EnumHelper } from "ui/Scripts/source/models/enums";

export interface ICompanyListItem {
    id: string;
    code: string;
    name: string;
    logo: string;
    activeState: number;
    fileStorageQuota: number;
    usedStoragePercent: number;
    usedFileStorageQuota: number;
    companyGroups: string[];

    activeStateStr: string;
    companyGroupsStr: string;
}

export class CompanyListItem implements ICompanyListItem {
    id: string;
    code: string;
    name: string;
    logo: string;
    activeState: number;
    fileStorageQuota: number;
    usedStoragePercent: number;
    usedFileStorageQuota: number;
    companyGroups: string[];

    activeStateStr: string;
    companyGroupsStr: string;

    constructor();
    constructor(obj: ICompanyListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.logo = obj && obj.logo || "";
        this.activeState = obj && obj.activeState || 0;
        this.fileStorageQuota = obj && obj.fileStorageQuota || 0;
        this.usedStoragePercent = obj && obj.usedStoragePercent || 0;
        this.usedFileStorageQuota = obj && obj.usedFileStorageQuota || 0;
        this.companyGroups = obj && obj.companyGroups || [];
        this.activeStateStr = CompanyListItem.getActiveStateToStr(this.activeState);
        this.companyGroupsStr = Base.getStringWithSeparators(this.companyGroups, ", ");
    }

    static getActiveStateToStr(activeState: number): string {
        if (EnumHelper.isEqual(activeState, CompanyActiveState.InUse)) return Translations.InUse;
        if (EnumHelper.isEqual(activeState, CompanyActiveState.InTesting)) return Translations.InTesting;
        return Translations.NotInUse;
    }

    static sortCompanyListItems(items: ICompanyListItem[], column: string, asc: boolean): ICompanyListItem[] {
        if (!items && items.length < 2) return items;
        if (column === "name") {
            return items.sort((a: ICompanyListItem, b: ICompanyListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.name, b.name)); });
        } else if (column === "code") {
            return items.sort((a: ICompanyListItem, b: ICompanyListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        } else if (column === "activeState") {
            return items.sort((a: ICompanyListItem, b: ICompanyListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.activeState, b.activeState)); });
        } else if (column === "usedStoragePercent") {
            return items.sort((a: ICompanyListItem, b: ICompanyListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.usedStoragePercent, b.usedStoragePercent)); });
        } else {
            return items.sort((a: ICompanyListItem, b: ICompanyListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.companyGroupsStr, b.companyGroupsStr)); });
        }
    }
}